module.exports = __webpack_public_path__ + "img/p20.185c2e79.png";